<template>
    <div>
        <div class="row mb-1">
            <div class="col-sm-3 "><strong>Company name:</strong></div>
            <div class="col-sm-9">Motorica LLC</div>
        </div>
        <div class="row mb-1">
            <div class="col-sm-3 "><strong>Phone:</strong></div>
            <div class="col-sm-9">+7 495 104-95-35</div>
        </div>
        <div class="row mb-1">
            <div class="col-sm-3 "><strong>Email:</strong></div>
            <div class="col-sm-9">global@motorica.org</div>
        </div>
        <div class="row mb-1">
            <div class="col-sm-3 "><strong>Addresses:</strong></div>
            <div class="col-sm-9">
                <div class="row mb-1">
                    
                    <div class="col-sm-12">Skolkovo Technopark, 42 Bolshoy boulevard, Skolkovo Innovation center, Moscow, 121205 Russia</div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    //import i18n from '@/lang'
    export default{
        name: 'en',
        data() {
            return{
               
            }
        },
 

    }
</script>
